import { RootState } from '../../types/redux/states/RootState';

export const getVentureId = ({ visitor }: RootState): string => visitor.ventureId as string;
